import { useEffect, useState } from 'react';
import {
    asyncGetAccount,
    asyncGetAccountHistorical,
} from '../../../../../services/accounts.service';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Account,
    AccountHistorical,
} from '../../../../../shared/types/modules/account';
import { ACCOUNTS } from '../../../../../routes/paths';

export const useAccountDetail = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idAccount } = useParams();
    const [loading, setLoading] = useState(false);
    const [account, setAccount] = useState<Account>();
    const [accountHistorical, setAccountHistorical] =
        useState<AccountHistorical[]>();

    useEffect(() => {
        if (Boolean(idAccount?.trim())) {
            setLoading(true);
            asyncGetAccount(idAccount?.trim())
                .then((account) => {
                    if (account) setAccount(account);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idAccount]);

    useEffect(() => {
        if (Boolean(idAccount?.trim()) && showHistorical) {
            asyncGetAccountHistorical(idAccount?.trim()).then((resp) => {
                if (resp) setAccountHistorical(resp);
                else navigate(ACCOUNTS);
            });
        }
    }, [showHistorical]);

    return { loading, account, accountHistorical };
};
